<template lang="pug">
  #tbody.tbody
    router-link.table-row(
    :to="{name: 'RecordDetailsPage', params: {id: id}}"
    v-for="{entity: {legalAddress: {country}, status, legalName}, lei, id, registration}, i in items",
    v-if="i < perPage", :key="i",
    :class="{selected: checkedItems[id]}")
      .table-cells
        .table-cell.country
          img.flag(:src="getCountryFlagByCode(country)")
          a.default.w-7.ellipsis {{ getCountryNameByCode(country)}}
        .table-cell.entity-status
          lei-status(:status="status")
            a.default-bold.w-6.ellipsis {{ status }}
        .table-cell.legal-name
          a.default-bold.ellipsis {{ legalName.name }}
        .table-cell.lei
          a.default-bold.w-6.ellipsis {{ lei }}
        .table-cell.reg-status
          lei-status(:status="registration.status")
            a.default-bold.w-6.ellipsis {{ registration.status }}
        //.table-cell.selection(@click.stop="")
          //font-awesome-icon.dots(icon="ellipsis-h")
          .checkbox
            input(type="checkbox", :id="id", @change="selectRow($event, id)")
            label(:for="id")
      .mobile-card(@click="showRecordDetails(lei)")
        .content
          //.prop.country
            img.flag(:src="getCountryFlag(legaladdress.country)")
            a.w-7 {{ getCountryName(legaladdress.country)}}
          .prop.legal-name
            a.default-bold.ellipsis {{ legalName.name }}
          .prop.lei
            a.default-bold.w-6.ellipsis {{ lei }}
        .footer
          .prop.statuses
            .status.entity-status
              lei-status(:status="status")
                a.default-bold.w-6.ellipsis {{ status }}
            .status.reg-status
              lei-status(:status="registration.status")
                a.default-bold.w-6.ellipsis {{ registration.status }}
          .prop.actions
            .go-to(@click="showRecordDetails(lei)")
              font-awesome-icon.angle(icon="angle-right")
      //.table-row-additional
        .matches
          label.w-6 Matches
            a.w-7  Entity Name
        .actions
          font-awesome-icon.bell(icon="bell", size="lg")
</template>
<script>
import { getCountryFlagByCode, getCountryNameByCode, } from '../../utils/countries'
import { mapMutations, mapState, } from 'vuex'
import { SELECT_ROW, } from '../../store/modules/search/mutations-types'
import routerSearch from '../../mixins/router-search-mixin'
import LeiStatus from '../lei-components/LeiStatus'

export default {
  components: { LeiStatus, },
  mixins: [ routerSearch, ],
  computed: {
    ...mapState('search', [ 'items', 'checkedItems', 'perPage', ]),
  },
  methods: {
    getCountryNameByCode,
    getCountryFlagByCode,
    selectRow ({ target: { checked, }, }, id) {
      this.selectItem({
        id,
        checked,
      })
    },
    showRecordDetails (id) {
      this.$router.push({
        name: 'RecordDetailsPage',
        params: { id: id, },
      })
    },

    ...mapMutations('search', {
      selectItem: SELECT_ROW,
    }),
  },
}
</script>
<style lang="stylus">
  @import "../../assets/styles/variables.styl"
  #result-list
    .tbody
      display flex
      flex-direction column
      justify-content space-between
      margin 15px 0
      font-size 80%

      .mobile-card
        display none

      .status-icon
        margin-right 8px

    .table-row
      cursor pointer
      background-color $default-color-light-2
      border-radius 4px
      //border 2px solid transparent
      margin 5px 0
      &.selected
        border 2px solid $primary-color

    .table-row-additional
      display flex
      padding 10px 15px
      justify-content space-between
      align-items center
      border-top 2px solid $default-color-light-1

    .table-cells
      display flex
      justify-content space-between
      min-height 50px

    .status-icon
      margin-right 8px

    .table-cell
      height 50px
      display flex
      padding 10px 15px
      align-items center
      & > a
        line-height 1rem
      &.selection
        justify-content flex-end
        .dots
          color $default-color-light-1
          font-size 2rem

    .checkbox
      width 1rem
      height 1rem
      position relative
      user-select none
      label
        cursor pointer
        &:before, &:after
          top 50%
          left 50%
          transform translateX(-50%) translateY(-50%)
          content ''
          position absolute
          border-radius 20%

        &:before
          width 1rem
          height 1rem
          background $white-color
          border 1px solid $default-color

        &:after
          width 0.7rem
          height 0.7rem
          opacity 0
          background $info-color

      input
        position absolute
        visibility hidden

        &:checked + label
          &:after
            opacity 1

  @media screen and (max-width: $laptop-l) and (min-width: $laptop)
    #result-list
      .tbody
        font-size 75%

  @media screen and (max-width: $laptop)
    #result-list
      .tbody
        order 1

      .table-cell
        &.selection
          display none

  @media screen and (max-width: $tablet)
    #result-list
      .table-cells
        display none

      .table-row-additional
        display none

      .table-row
        border-radius 0

      .tbody .mobile-card
        display flex

      .mobile-card
        cursor pointer
        flex-direction column
        padding 5px
        .content
          display flex
          flex-direction column
        .footer
          display flex
          justify-content space-between
        .prop
          display flex
          padding 5px
          align-items center
          &.statuses
            display flex
            flex-flow row wrap
            .entity-status
              margin-right 25px
          &.actions
            align-self flex-end
            .go-to
              cursor pointer
              display flex
              justify-content center
              color white
              width 20px
              height 20px
              background-color $primary-color
              align-items center
              .angle
                font-size 1rem
</style>



// WEBPACK FOOTER //
// src/components/data-table/TBody.vue